<!--
 * @Date: 2025-01-22 10:30:10
 * @LastEditors: furan NgeKaworu@gmail.com
 * @LastEditTime: 2025-05-08 14:58:05
 * @FilePath: /newwork-h5/src/App.vue
-->
<template>
  <div>
    <keep-alive :include="cachedComponents">
      <router-view />
    </keep-alive>
    <van-dialog v-model="show" :title="$t('系统登录密码修改通知')" @confirm="confirm" @cancel="cancel"
      :cancelButtonText="$t('我知道了')" :confirmButtonText="$t('去修改')" :show-cancel-button="!isFirstLogin">
      <p class="noticeMessage" v-if="isFirstLogin">{{ $t('初始密码安全等级较低，需修改密码') }}</p>
      <p class="noticeMessage" v-else>{{ $t('您的系统密码较长时间未修改，存在安全隐患，请前去修改！') }}</p>
    </van-dialog>
  </div>
</template>
<script>
import {
  getUserLasterUpdateTime,
  updateUserLasterUpdateTime,
  getCompanyInfo
} from '@/services/api'
import dayjs from 'dayjs'

import Vue from 'vue'
import { Dialog } from 'vant'

Vue.use(Dialog)
export default {
  name: 'App',
  data() {
    return {
      show: false,
      cachedComponents: ['NewInvitation'],
      isFirstLogin: false,
      userInfo: {},
      companyInfo: {},
      companyCode: '',
      hasCheckedFirstLogin: false,
    }
  },
  async mounted() {
    this.userId = JSON.parse(localStorage.getItem('user'))?.id
    this.userInfo = JSON.parse(localStorage.getItem('user'))
    this.companyCode = JSON.parse(localStorage.getItem('cCode'))?.code
  },

  methods: {
    confirm() {
      if (this.userId) {
        updateUserLasterUpdateTime(this.userId)
        this.$router.push({
          path: '/changePwd',
          query: {
            isFirstLogin: this.isFirstLogin,
          },
        })
      }
    },
    cancel() {
      if (this.userId) {
        updateUserLasterUpdateTime(this.userId)
      }
    },
    addCache(componentName) {
      if (!this.cachedComponents.includes(componentName)) {
        this.cachedComponents.push(componentName)
      }
    },
    removeCache(componentName) {
      this.cachedComponents = this.cachedComponents.filter(name => name !== componentName)
    },
  },
  watch: {
    $route: {
      async handler(val, oldval) {
        if (!this.userInfo) {
          this.userInfo = JSON.parse(localStorage.getItem('user'))
        }
        if (!this.companyCode) {
          this.companyCode = JSON.parse(localStorage.getItem('cCode'))?.code
        }
        console.log(this.hasCheckedFirstLogin);

        if (this.companyCode && !this.hasCheckedFirstLogin) {

          try {
            this.companyInfo = await getCompanyInfo(this.companyCode)
            this.hasCheckedFirstLogin = true
          } catch (error) { }
        }
        if (this.companyInfo && this.userInfo) {
          this.isFirstLogin =
            this.companyInfo?.openFirstCheck &&
            (this.userInfo?.isFirstLogin === undefined || this.userInfo?.isFirstLogin === true)
          if (
            this.isFirstLogin &&
            val.path !== '/changePwd' &&
            val.path !== '/robot/publicnewInvitation'
          ) {
            this.show = true
          }
          console.log(this.isFirstLogin, 'isFirstLogin')
          console.log(this.companyInfo, 'companyInfo')
          console.log(this.userInfo, 'userInfo')
        }
        if (!this.userId) {
          this.userId = JSON.parse(localStorage.getItem('user'))?.id
        }

        try {
          if (this.userId && !this.isFirstLogin) {
            const res = await getUserLasterUpdateTime(this.userId)
            // 用户无时间戳，直接更新
            if (!res) {
              await updateUserLasterUpdateTime(this.userId)
              return
            }

            // 超过30天，提醒用户
            const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
            const diffDay = dayjs(now).diff(dayjs(res), 'day')

            if (
              val.path !== '/changePwd' &&
              val.path !== '/robot/publicnewInvitation' &&
              diffDay > 30
            ) {
              this.show = true
            }
          }
        } catch (error) {
          console.log('err:', error)
        }

        console.log(oldval, val)
        if (oldval.name === 'NewInvitation') {
          if (val.name === 'Visitors') {
            oldval.query.visitorId
              ? this.removeCache('NewInvitation')
              : this.addCache('NewInvitation')
          } else if (val.name === 'Robot' || val.name === 'VisitorInfo') {
            this.removeCache('NewInvitation')
          } else if (val.name === 'SendInvitation' || val.name === 'FaceTips') {
            this.addCache('NewInvitation')
          }
        } else if (
          (oldval.name === 'Robot' || oldval.name === 'Visitors') &&
          val.name === 'NewInvitation'
        ) {
          this.addCache('NewInvitation')
        } else if (
          (oldval.name === 'NewInvitation' || oldval.name === 'Login') &&
          (val.name === 'SendInvitation' || val.name === 'FaceTips')
        ) {
          this.addCache('NewInvitation')
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
}
</script>
<style lang="less" scoped>
#app {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.noticeMessage {
  padding: 8px 14px;
  font-size: 14px;
  text-align: center;
}
</style>
